module.exports = __webpack_public_path__ + "static/media/app-store-badge.3c91871e.svg";